import { render } from "./PauseModal.vue?vue&type=template&id=f2dbb438"
import script from "./PauseModal.vue?vue&type=script&lang=js"
export * from "./PauseModal.vue?vue&type=script&lang=js"

import "./PauseModal.vue?vue&type=style&index=0&id=f2dbb438&lang=scss"

import exportComponent from "/Users/boris/Developer/me/git/retro-puzzle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__